import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapp-ad-section',
  templateUrl: './webapp-ad-section.component.html',
  styleUrls: ['./webapp-ad-section.component.css']
})
export class WebappAdSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
